import { render } from "./OrdersFiltersModal.vue?vue&type=template&id=7dd72950"
import script from "./OrdersFiltersModal.vue?vue&type=script&lang=js"
export * from "./OrdersFiltersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__